module.exports = __webpack_public_path__ + "img/2.aca03e82.jpg";